var React = require('react');

function IconHourglassEnd (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64V75c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9C48.9 353.9 32 394.6 32 437v11c-17.7 0-32 14.3-32 32s14.3 32 32 32H64 320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V437c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320 64 32zM96 75V64H288V75c0 25.5-10.1 49.9-28.1 67.9L192 210.7l-67.9-67.9C106.1 124.9 96 100.4 96 75z"}));
}

IconHourglassEnd.defaultProps = {"viewBox":"0 0 384 512","fill":"currentColor"};

module.exports = IconHourglassEnd;

IconHourglassEnd.default = IconHourglassEnd;
